/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { useGetBooksMutation } from '@partiu/api/bookstore/hooks';
import { IBook, PaginatedResponse, Params } from '@partiu/api/types';
import { FaFrown } from 'react-icons/fa';
import { UseMutationOptions, UseMutationResult } from 'react-query';
import { InfiniteScroll } from '../../../../../packages/ui/components/atoms/InfiniteScroll';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { BookCard } from '../molecules/BookCard';

export function BookGrid({
  filters = {},
  mutationHook = useGetBooksMutation,
  emptyTitle,
  emptyDescription,
  showEditorialCode = true,
}: {
  filters?: Params;
  mutationHook?: (
    options: UseMutationOptions<PaginatedResponse<IBook>, unknown, Params, unknown>
  ) => UseMutationResult<PaginatedResponse<IBook>, unknown, Params, unknown>;
  emptyTitle?: string;
  emptyDescription?: string;
  showEditorialCode?: boolean;
}) {
  const { id } = useTheme();

  const renderItem = (book: any) => {
    return <BookCard grid isActive={false} book={book.book ? book.book : book} showEditorialCode={showEditorialCode} />;
  };

  if (!id) return <></>;

  return (
    <Box w={'100%'} mt="20px" paddingBottom={'80px'}>
      <InfiniteScroll
        keyExtraction={(book) => book.id.toString()}
        renderItem={renderItem}
        emptyResultsComponent={
          <VStack paddingTop={'50px'} spacing={3}>
            <FaFrown size="36px" color="#999" />
            <SectionTitle color="black">{emptyTitle || 'Nenhuma obra encontrada'}</SectionTitle>
            {emptyDescription && (
              <Box as="p" fontSize="14px" color="#888" textAlign="center" maxW="300px">
                {emptyDescription}
              </Box>
            )}
          </VStack>
        }
        mutationHook={mutationHook}
        hookProps={filters}
      >
        {(items) => {
          return (
            <SimpleGrid gap={3} spacing={0} columns={{ base: 2, lg: 6 }}>
              {items}
            </SimpleGrid>
          );
        }}
      </InfiniteScroll>
    </Box>
  );
}
